/** Party role helpers.
 *
 * A party's capability can come from its `party_type` or from its `roles` array - Flippex is
 * a single `platform` party that also acts as developer and issuer. Always ask through here,
 * never compare `party_type` directly, or multi-role parties vanish from pickers.
 */
export const hasPartyRole = (party, roles) => {
  if (!party) return false;
  const wanted = Array.isArray(roles) ? roles : [roles];
  if (wanted.includes(party.party_type)) return true;
  return (party.roles || []).some((r) => wanted.includes(r));
};

export const isDeveloperParty = (party) => hasPartyRole(party, ['developer', 'sponsor']);

export const isIssuerParty = (party) => hasPartyRole(party, ['issuer']);

export const developerParties = (parties = []) => parties.filter(isDeveloperParty);

export const issuerParties = (parties = []) => parties.filter(isIssuerParty);
